
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire293c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire293c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c286w", function(module, exports) {
class $61b781b208693d9b$var$ConstDavosMenu extends HTMLUListElement {
    connectedCallback() {
        let current = this.getAttribute("current");
        if (current) {
            let currentElem = this.querySelector("." + current);
            if (currentElem) currentElem.classList.add("current");
        }
    }
}
customElements.define("const-davos-menu", $61b781b208693d9b$var$ConstDavosMenu, {
    extends: "ul"
});

});

parcelRegister("gvZNN", function(module, exports) {
function $2b6efd5ed343cc56$var$setCurrent(imgElem) {
    imgElem.setAttribute("current", "current");
    imgElem.style.display = null;
}
function $2b6efd5ed343cc56$var$resetCurrent(imgElem) {
    imgElem.removeAttribute("current");
    imgElem.style.display = "none";
}
function $2b6efd5ed343cc56$var$findCurrentIndex(imgs) {
    for(let i = 0; i < imgs.length; ++i){
        if (imgs[i].hasAttribute("current")) return i;
    }
    return -1;
}
class $2b6efd5ed343cc56$var$ConstDavosGallery extends HTMLElement {
    connectedCallback() {
        this.prev = document.createElement("div");
        this.prev.classList.add("ctrl");
        this.prev.classList.add("prev");
        this.prev.innerHTML = "&lt;";
        this.next = document.createElement("div");
        this.next.classList.add("ctrl");
        this.next.classList.add("next");
        this.next.innerHTML = "%gt;";
        this.insertBefore(this.prev, this.firstChild);
        this.appendChild(this.next);
        let imgs = this.querySelectorAll("const-davos-gallery-img");
        let hasCurrent = false;
        for(let i = 0; i < imgs.length; ++i){
            let imgElem = imgs[i];
            if (!hasCurrent && imgElem.hasAttribute("current")) {
                hasCurrent = true;
                continue;
            }
            $2b6efd5ed343cc56$var$resetCurrent(imgElem);
        }
        if (!hasCurrent && imgs.length) {
            let imgElem = imgs[0];
            $2b6efd5ed343cc56$var$setCurrent(imgElem);
        }
        this.querySelector(".ctrl.prev").addEventListener("click", (ev)=>{
            this.onPrev(ev);
        });
        this.querySelector(".ctrl.next").addEventListener("click", (ev)=>{
            this.onNext(ev);
        });
        this.addEventListener("swipe-left", (ev)=>this.onPrev(ev));
        this.addEventListener("swipe-right", (ev)=>this.onNext(ev));
    }
    onPrev(ev) {
        let imgs = this.querySelectorAll("const-davos-gallery-img");
        if (!imgs.length) return;
        let currentIndex = $2b6efd5ed343cc56$var$findCurrentIndex(imgs);
        let prevIndex = currentIndex == -1 ? 0 : (currentIndex - 1 + imgs.length) % imgs.length;
        if (currentIndex == prevIndex) return;
        $2b6efd5ed343cc56$var$setCurrent(imgs[prevIndex]);
        if (currentIndex != -1) $2b6efd5ed343cc56$var$resetCurrent(imgs[currentIndex]);
        ev.stopPropagation();
        ev.preventDefault();
    }
    onNext(ev) {
        let imgs = this.querySelectorAll("const-davos-gallery-img");
        if (!imgs.length) return;
        let currentIndex = $2b6efd5ed343cc56$var$findCurrentIndex(imgs);
        let nextIndex = (currentIndex + 1 + imgs.length) % imgs.length;
        if (currentIndex == nextIndex) return;
        $2b6efd5ed343cc56$var$setCurrent(imgs[nextIndex]);
        if (currentIndex != -1) $2b6efd5ed343cc56$var$resetCurrent(imgs[currentIndex]);
        ev.stopPropagation();
        ev.preventDefault();
    }
}
class $2b6efd5ed343cc56$var$ConstDavosGalleryImg extends HTMLElement {
    constructor(){
        super();
        this.pointerDownListener = (ev)=>this.onPointerDown(ev);
        this.pointerMoveListener = (ev)=>this.onPointerMove(ev);
        this.pointerUpListener = (ev)=>this.onPointerUp(ev);
        this.pointerOutListener = (ev)=>this.onPointerOut(ev);
        this.pointerDownX = undefined;
    }
    connectedCallback() {
        this.img = this.querySelector("img");
        this.img.addEventListener("pointerdown", this.pointerDownListener);
        this.addEventListener("pointermove", this.pointerMoveListener);
        this.addEventListener("pointerup", this.pointerUpListener);
        this.addEventListener("pointerout", this.pointerOutListener);
    }
    disconnectedCallback() {
        this.img.removeEventListener("pointerdown", this.pointerDownListener);
        this.removeEventListener("pointermove", this.pointerMoveListener);
        this.removeEventListener("pointerup", this.pointerUpListener);
        this.removeEventListener("pointerout", this.pointerOutListener);
    }
    onPointerDown(ev) {
        if (ev.ctrlKey || ev.altKey || ev.metaKey || ev.shiftKey) return;
        this.pointerDownX = ev.clientX;
    }
    onPointerMove(ev) {}
    onPointerUp(ev) {
        if (this.pointerDownX == null) return;
        const delta = ev.clientX - this.pointerDownX;
        this.pointerDownX = undefined;
        if (Math.abs(delta) < 20) return;
        if (delta < 0) this.dispatchEvent(new Event("swipe-left", {
            bubbles: true
        }));
        else this.dispatchEvent(new Event("swipe-right", {
            bubbles: true
        }));
    }
    onPointerOut(ev) {}
}
customElements.define("const-davos-gallery", $2b6efd5ed343cc56$var$ConstDavosGallery);
customElements.define("const-davos-gallery-img", $2b6efd5ed343cc56$var$ConstDavosGalleryImg);

});

parcelRequire("c286w");
parcelRequire("gvZNN");


//# sourceMappingURL=apartments.64888778.js.map
